import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginContext from './LoginContext';
import { API_BASE_URL } from '../constants/apiConfig';
import { GoogleLogin } from '@react-oauth/google';

const LoginPage = () => {
  const navigate = useNavigate();
  const { setIsLoggedIn, setUserRole, userRole, setUserName, setUserId }: any = useContext(LoginContext);
  const [credentials, setCredentials] = useState({
    username: '',
    password: '',
  });
  const [loginStatus, setLoginStatus] = useState({ status: 0, message: '' });

  const changeHandler = (e: any) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value,
    });
  };

  const submitHandler = () => {
    setLoginStatus({
      ...loginStatus,
      message: '',
    });
    fetch(`${API_BASE_URL}/admin/login`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(credentials),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status > 0) {
          setLoginStatus({
            status: 1,
            message: data.message,
          });
          setUserRole(data.role); // Assuming the response includes the user's role
        } else {
          setLoginStatus({
            status: 0,
            message: data.message,
          });
        }
      });
  };

  const handleGoogleLoginSuccess = (credentialResponse: any) => {
    setLoginStatus({
      ...loginStatus,
      message: 'Verifying with Google...',
    });

    // Send the Google token to your backend for verification
    fetch(`${API_BASE_URL}/admin/google-login`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        token: credentialResponse.credential,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status > 0) {
          setLoginStatus({
            status: 1,
            message: 'Login successful!',
          });
          setUserRole(data.role); // Assuming the response includes the user's role
          setUserName(data.name); // Assuming the response includes the user's name
          setUserId(data.userId); // Assuming the response includes the user's ID
        } else {
          setLoginStatus({
            status: 0,
            message: data.message || 'Google login failed',
          });
        }
      })
      .catch((error) => {
        setLoginStatus({
          status: 0,
          message: 'Error during Google login: ' + error.message,
        });
      });
  };

  const handleGoogleLoginError = () => {
    setLoginStatus({
      status: 0,
      message: 'Google login failed. Please try again.',
    });
  };

  useEffect(() => {
    if (loginStatus.status > 0) {
      setIsLoggedIn(true);
        if(userRole === "admin"){
        navigate("/addqus");
      }else{
        navigate("/dashboard");
      }
    }
  }, [loginStatus.status, setIsLoggedIn, navigate, userRole]);

  return (
    <div className="bg-base-200 flex items-center justify-center p-4">
      <div className="card lg:card-side bg-base-100 shadow-xl w-full overflow-hidden">
        
        {/* Left Side: Image Card */}
        <figure className="lg:w-1/2 h-64 lg:h-auto">
          <img 
            src="/asset/login_pic.jpg" 
            alt="Welcome" 
            className="w-full h-full object-cover"
          />
        </figure>

        {/* Right Side: Login Form */}
        <div className="card-body lg:w-1/2">
          <h2 className="card-title text-3xl font-bold mb-4">Welcome Back</h2>
          
          <form onSubmit={(e) => e.preventDefault()}>
            {/* Username Field */}
            <div className="form-control mb-4">
              <label className="label">
                <span className="label-text">Username</span>
              </label>
              <input 
                type="text" 
                placeholder="Enter your username" 
                className="input input-bordered w-full" 
                name="username"
                value={credentials.username}
                onChange={changeHandler}
                required 
              />
            </div>

            {/* Password Field */}
            <div className="form-control mb-2">
              <label className="label">
                <span className="label-text">Password</span>
              </label>
              <input 
                type="password" 
                placeholder="••••••••" 
                className="input input-bordered w-full" 
                name="password"
                value={credentials.password}
                onChange={changeHandler}
                required 
              />
            </div>

            {/* Forgot Password */}
            <div className="text-right mb-6">
              <a href="/" className="link link-primary link-hover text-sm btn-disabled opacity-50">
                Forgot password?
              </a>
            </div>

            {/* Login Status Message */}
            {loginStatus.message && (
              <div className={`alert mb-4 ${loginStatus.status > 0 ? 'alert-success' : 'alert-error'}`}>
                <span>{loginStatus.message}</span>
              </div>
            )}

            {/* Sign In Button */}
            <div className="form-control mt-6 gap-3">
              <button 
                type="button"
                className="btn btn-primary"
                onClick={submitHandler}
              >
                Sign In
              </button>
              
              <div className="divider">OR</div>

              {/* Google Login Button */}
              <div className="w-full">
                <GoogleLogin
                  onSuccess={handleGoogleLoginSuccess}
                  onError={handleGoogleLoginError}
                />
              </div>
            </div>
          </form>
        </div>

      </div>
    </div>
  );
};

export default LoginPage;
